import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../../images/clean-your-lists-transparent-logo.png";
import "../../css/animate.min.css";
import "../../css/login.css";
import { forgotPasswordHandleChange } from "../../common/actions";
import { forgotPasswordAction } from "../../Containers/Login/actions";
import Overlay from "../../utility/overlay";

import {
  forgotPasswordValidators,
  updateValidators,
  initValidations,
} from "../../utility/validations";

import { ValidationSummary } from "../../utility/ValidationSummary";
import FormSubmit from "../Forms/Submit";
import FormInput from "../Forms/Input";
import leftPanelIcon from "../../images/login-screen.png";

const mapStateToProps = (state) => ({
  forgotPasswordInfo: state.forgotPasswordInfo,
});
class ForgotPassword extends Component {
  constructor() {
    super();

    this.state = { showErrorSummary: false };
    this.validators = forgotPasswordValidators;

    initValidations(this.validators);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(forgotPasswordHandleChange("username", ""));
    document.body.classList.add("bgColor");
  }
  componentWillUnmount() {
    document.body.classList.remove("bgColor");
  }
  handleChange(event) {
    this.props.dispatch(
      forgotPasswordHandleChange(event.target.name, event.target.value)
    );
    updateValidators(this.validators, event.target.name, event.target.value);
  }
  handleSubmit(event) {
    event.preventDefault();
    this.setState({ showErrorSummary: true });

    if (this.validators.errorSummary.length == 0) {
      const { username } = this.props.forgotPasswordInfo;
      this.props.dispatch(forgotPasswordAction({ username }));
    }
  }
  render() {
    return (
      <div className="signup-container">
        {this.state.showErrorSummary ? (
              <ValidationSummary errorMsg={this.validators.errorSummary} />
            ) : null}
        <div className="login-image"></div>
        <div className="section-form">
          <form style={{ overflow: "hidden" }} onSubmit={this.handleSubmit}>
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <h1>
                <a
                  href="https://cleanyourlists.com/"
                  target="_blank"
                >
                  <img src={logo} alt="logo" width="320" />
                </a>
              </h1>
              <p style={{ fontSize: 35, paddingTop: 65 }}>
                <b>Forgot Password</b>
              </p>
              <FormInput
                type={"email"}
                placeholder="Please Enter Email"
                name="username"
                onChange={this.handleChange}
                value={this.props.forgotPasswordInfo.username}
                styles={{ marginBottom: 10, width: "80%" }}
              />
              <FormSubmit
                value="Submit"
                styles={{
                  marginTop: 5,
                  marginBottom: 10,
                  color: "#fff",
                  width: "80%",
                  background: "#272759",
                }}
              />
              <Link
                  style={{ fontSize: 16, color: "#52a792" }}
                  to="/resendactivation"
                >
                  Resend Activation
              </Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/Login/ForgotPassword.js